import { z } from "zod";
import { LookupListPage } from "@/pages/admin/lookups/LookupListPage";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface Row { calcType: string; calcName: string; description: string | null; canEditQuantity: boolean; deleted: boolean; }
const schema = z.object({
  calcType: z.string().min(1).max(40),
  calcName: z.string().min(1).max(80),
  description: z.string().max(500).nullable().optional(),
  canEditQuantity: z.boolean(),
  deleted: z.boolean(),
});
type Form = z.infer<typeof schema>;

export function BomCalcTypesPage() {
  return <LookupListPage<Row, Form>
    title="Calc types"
    apiPath="/api/lookups/bom-calc-types"
    schema={schema}
    rowKey={(r) => r.calcType}
    columns={[
      { id: "code", header: "Code", accessor: (r) => r.calcType },
      { id: "name", header: "Name", accessor: (r) => r.calcName },
      { id: "editqty", header: "Edit qty", accessor: (r) => (r.canEditQuantity ? "Yes" : "—") },
    ]}
    toFormValues={(r) => ({ calcType: r.calcType, calcName: r.calcName, description: r.description ?? "", canEditQuantity: r.canEditQuantity, deleted: r.deleted })}
    toApiBody={(f) => ({ ...f, description: f.description === "" ? null : f.description })}
    blankFormValues={{ calcType: "", calcName: "", description: "", canEditQuantity: false, deleted: false }}
    fields={(f) => (
      <div className="space-y-3">
        <div><Label htmlFor="c">Code</Label><Input id="c" {...f.register("calcType")} /></div>
        <div><Label htmlFor="n">Name</Label><Input id="n" {...f.register("calcName")} /></div>
        <div><Label htmlFor="d">Description</Label><Input id="d" {...f.register("description")} /></div>
        <label className="flex items-center gap-2"><input type="checkbox" {...f.register("canEditQuantity")} /> Can edit quantity</label>
        <Button type="submit">Save</Button>
      </div>
    )}
  />;
}
